import {
  DEFAULT_ISLAND_KEY,
  getIslandAreaMapPoints,
  getIslandDefaultMapViewport,
} from 'alakai-aloha-shared';

const LEGACY_DEFAULT_VIEWPORT = Object.freeze({
  center: Object.freeze({ lat: 22.0964, lng: -159.5261 }),
  zoom: Object.freeze({ mobile: 10, desktop: 10 }),
});

function buildViewportFromAreaPoints(islandKey = DEFAULT_ISLAND_KEY) {
  const points = getIslandAreaMapPoints(islandKey).filter(
    (point) => Number.isFinite(point?.lat) && Number.isFinite(point?.lng),
  );

  if (!points.length) {
    return null;
  }

  const latitudes = points.map(({ lat }) => lat);
  const longitudes = points.map(({ lng }) => lng);
  const minLat = Math.min(...latitudes);
  const maxLat = Math.max(...latitudes);
  const minLng = Math.min(...longitudes);
  const maxLng = Math.max(...longitudes);
  const maxSpan = Math.max(maxLat - minLat, maxLng - minLng);

  let desktopZoom = 10;
  if (maxSpan >= 2) {
    desktopZoom = 7;
  } else if (maxSpan >= 1) {
    desktopZoom = 8;
  } else if (maxSpan >= 0.6) {
    desktopZoom = 9;
  } else if (maxSpan >= 0.3) {
    desktopZoom = 10;
  } else {
    desktopZoom = 11;
  }

  return {
    center: {
      lat: (minLat + maxLat) / 2,
      lng: (minLng + maxLng) / 2,
    },
    zoom: {
      mobile: Math.max(6, desktopZoom - 1),
      desktop: desktopZoom,
    },
  };
}

export function getCatalogMapViewport(islandKey = DEFAULT_ISLAND_KEY) {
  return (
    getIslandDefaultMapViewport(islandKey) ??
    buildViewportFromAreaPoints(islandKey) ??
    LEGACY_DEFAULT_VIEWPORT
  );
}

export function fitMapToIslandAreaPoints(map, islandKey = DEFAULT_ISLAND_KEY, padding = 32) {
  if (!map || typeof window === 'undefined' || !window.google?.maps) {
    return false;
  }

  const points = getIslandAreaMapPoints(islandKey).filter(
    (point) => Number.isFinite(point?.lat) && Number.isFinite(point?.lng),
  );

  if (!points.length) {
    return false;
  }

  if (points.length === 1) {
    const viewport = getCatalogMapViewport(islandKey);
    map.setCenter({ lat: points[0].lat, lng: points[0].lng });
    map.setZoom(viewport?.zoom?.desktop ?? LEGACY_DEFAULT_VIEWPORT.zoom.desktop);
    return true;
  }

  const bounds = new window.google.maps.LatLngBounds();
  points.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
  map.fitBounds(bounds, padding);
  return true;
}
